export default "__VITE_ASSET__23c34e33__"